app.directive('destinationSectionFamilyMart', [
  'mainConfig',
  'familyMartService',
  'multiCheckoutService',
  function (mainConfig, familyMartService, multiCheckoutService) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.family-mart.html'),
      scope: {
        store: '=',
        disabled: '=',
        cartTagIds: '=',
        errorMessage: '=',
        updateDestination: '<',
      },
      link: function (scope) {
        scope.actionUrl = familyMartService.FAMILY_MART_E_MAP;
        scope.cvstemp = mainConfig.merchantData._id;
        scope.cvsname = mainConfig.familyMartConfig.cvsname;

        scope.onEMapSubmitClick = (event) => {
          event.preventDefault();
          scope
            .updateDestination()
            .then(() =>
              multiCheckoutService.saveSessionData({
                cart_tag_ids: scope.cartTagIds,
              }),
            )
            .then(() => {
              // No need to get domain token when env is production.
              if (mainConfig.familyMartEnv === 'prod') {
                $('#multi_checkout_family_mart')[0].submit();
                return;
              }
              familyMartService
                .getDomainToken()
                .then(({ data = {} }) => {
                  $('#multi_checkout_family_mart')
                    .find('input[name=cvstemp]:first')
                    .attr('value', data.token);
                  $('#multi_checkout_family_mart')[0].submit();
                })
                .catch((error) => {
                  console.error(error);
                });
            })
            .catch(() => {
              console.error('unable to open e-map of family mart.');
            });
        };
      },
    };
  },
]);
